import React from "react";
import SideNav from "../../Admin-component/SideNav";
const Dashboard = () => {
  return (
    <div>
      <SideNav />
    </div>
  );
};

export default Dashboard;
